import {useMutation, useQueryClient} from '@tanstack/react-query';
import {CampaignApprovalStep} from '@/types/campaign';
import campaignApprovalStepUpdaters from '@/api/updaters/campaignApprovalStep';
import updateCampaignApprovalStepsCache from '@/hooks/mutations/updateCampaignApprovalStepsCache';
import campaignQueryKey from '@/hooks/queries/use-campaign-query/campaignQueryKey';

function useRemoveCampaignApprovalStep({campaignId}: {campaignId: string}) {
  const queryClient = useQueryClient();
  const queryKey = campaignQueryKey(campaignId);

  return useMutation({
    mutationKey: ['campaignApprovalSteps', 'remove', campaignId],
    mutationFn: campaignApprovalStepUpdaters.remove,
    onMutate: async ({campaignApprovalStepId}) => {
      await queryClient.cancelQueries({queryKey});
      const snapshot = queryClient.getQueryData(queryKey);
      updateCampaignApprovalStepsCache(queryClient, queryKey, (steps) =>
        steps.filter(
          (cas: CampaignApprovalStep) => cas.id !== campaignApprovalStepId
        )
      );
      return {snapshot};
    },
    onError: (_err, _vars, context) => {
      queryClient.setQueryData(queryKey, context?.snapshot);
    },
    onSettled: () => {
      queryClient.invalidateQueries({queryKey});
    },
  });
}

export default useRemoveCampaignApprovalStep;
